import logEvent from 'analytics/logEvent';
import React from 'react';

import s from 'components/complex/payments/PaymentForm/SavedWallets/SavedWallets.module.scss';
import Wallet from 'components/complex/payments/PaymentForm/SavedWallets/Wallet';

import { useAppSelector } from 'redux-store';

interface Props {
  selectedWalletId: null | string;
  setSelectedWalletId: (id: null | string) => void;
}

export default function SavedWallets({
  selectedWalletId,
  setSelectedWalletId,
}: Props): JSX.Element | null {
  const paymentMethodsStore = useAppSelector(state => state.paymentsMethods);
  const { isFetched, paymentsMethods } = paymentMethodsStore;

  if (!isFetched) {
    return null;
  }

  const savedWallets = [
    ...new Map(
      paymentsMethods.map(item => [item.card.fingerprint, item]),
    ).values(),
  ].map(method => {
    const { id } = method;
    const isSelected = selectedWalletId === id;

    return (
      <Wallet
        onClick={(): void => {
          if (isSelected) {
            setSelectedWalletId(null);
          } else {
            setSelectedWalletId(id);
            logEvent('Web_Payment_Card_Selected');
          }
        }}
        key={id}
        method={method}
        isSelected={isSelected}
      />
    );
  });

  if (!savedWallets.length) {
    return null;
  }

  return <div className={s.walletsWrapper}>{savedWallets}</div>;
}
